<template>
    <div class="grid-x" id="comments" v-if="comments">
        <div class="cell comment">
            <h2 class="comment__header">{{labels.comments}}</h2>
            <div class="comment__item grid-x grid-margin-x" v-for="(comment, i) of comments" :key="i" :class="{ 'comment__item--mine': comment.isStudyOwner}">
                <div class="comment__author cell large-2">
                    <b class="comment__name">{{comment.userName}}</b>
                    <span class="text--blue">{{comment.date | formatDate }}</span>
                </div>
                <div class="comment__msg-wrapper cell large-8">
                    <div class="comment__msg">{{comment.comment}}</div>
                </div>
                <div class="comment__extra cell large-2"></div>
            </div>
            <div class="comment__item comment__item--mine grid-x grid-margin-x">
                <div class="cell large-2"></div>
                <div class="cell large-8">
                    <div class="comment__msg comment__input" :class="{ 'comment__input--active': comment }">
                        <textarea rows="6" id="comment" v-model="comment" v-floatable></textarea>
                        <label for="comment" class="floating-label">{{labels.writeComment}}</label>
                        <a tabindex="0" @click="postComment()" @keyup.enter="postComment()" class="button small">{{labels.sendComment}}</a>
                    </div>
                </div>
                <div class="cell large-2"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            comment: null,
            id: undefined
        };
    },
    computed: {
        comments() {
            return this.$store.state.comments;
        },
        labels() {
            return this.$store.state.labels["pages.mypage.comments"] || {};
        }
    },
    methods: {
        getComments() {
            if (typeof this.id !== 'undefined') {
                this.$store.dispatch('getComments', { studyId: this.id });
            }
        },
        postComment() {
            this.$store.dispatch('postComment', { studyId: this.id, comment: this.comment }).then((value) => {
                this.comment = null;
                this.getComments();
            })
        }
    },
    mounted() {
        this.id = this.$route.query.id;
        this.$store.dispatch('getLabels', { label: 'pages.mypage.comments' });
        this.getComments();
    }
};
</script>



// WEBPACK FOOTER //
// src/components/my-pages/Comments.vue